import { Component, OnInit } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { FetchAvaliableLanguagesRequest } from '@containers/i18n/store/i18n.actions'
import { LanguagesService } from '@containers/languages/languages.service'
import { FetchLanguagesListRequest } from '@containers/languages/store/languages.actions'
import { UpdateField } from '@containers/profile/profile.actions'
import { Store, select } from '@ngrx/store'
import ListTrait from '@traits/list.trait'
import { Map } from 'immutable'
import { Subscription } from 'rxjs'
import { getLanguagesList } from '../../store/languages.selector'

@Component({
  selector: 'app-languages-list',
  templateUrl: './languages-list.component.html',
  styleUrls: ['./languages-list.component.scss'],
})
export class LanguagesListComponent extends ListTrait implements OnInit {
  currentLanguage: string
  isLoading: boolean
  columns: object[] = [
    {
      prop: 'name',
      name: 'NAME',
      sortable: true,
    },
    {
      prop: 'iso2code',
      name: 'ISO2CODE',
      sortable: true,
    },
    {
      prop: 'isDefault',
      name: 'IS_DEFAULT',
      sortable: true,
      template: 'isDefaultColumn',
    },
    {
      prop: 'available',
      name: 'AVAILABLE',
      sortable: true,
      template: 'availableColumn',
    },
    {
      width: '162px',
      name: '',
      template: 'actionsColumn',
    },
  ]

  private _subs: Array<Subscription> = []

  constructor(
    private store: Store<any>,
    private activatedRoute: ActivatedRoute,
    public router: Router,
    private languagesService: LanguagesService,
  ) {
    super(router)
    this.getState()
  }

  ngOnInit() {
    this.getParams()
  }

  ngOnDestroy(): void {
    this._subs.filter((sub) => Boolean(sub)).forEach((sub) => sub.unsubscribe())
  }

  getParams() {
    const sub = this.activatedRoute.queryParams.subscribe((params) => {
      this.runFilter(params)
    })

    this._subs.push(sub)
  }

  runFilter(queryParams) {
    const { page, page_size } = this.state.get('queryParams').toJS()
    const params: any = { page, page_size, ...queryParams }

    this.store.dispatch<any>(
      new FetchLanguagesListRequest({
        filters: params.keyword
          ? {
              or: [{ field: 'name', value: params.keyword }],
            }
          : {},
        pageSize: parseInt(params.page_size),
        page: parseInt(params.page) - 1,
        sort: {
          order: params.sort?.toUpperCase(),
          prop: params.order_by,
        },
      }),
    )

    this.store.dispatch(new UpdateField('queryParams', params, 'languagesList'))
  }

  private getState() {
    const s = this.store.pipe(select(getLanguagesList)).subscribe((state) => {
      this.state = state
      this.isLoading = state.get('isLoading')
    })

    this._subs.push(s)
  }

  deleteLanguageRow(iso2code: string) {
    this.languagesService.deleteLanguage(iso2code).subscribe((res) => {
      this.store.dispatch(new FetchAvaliableLanguagesRequest())
      this.runFilter({})
    })
  }
}
